import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { organizationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useRemoveOrganizationUser = options => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(body => organizationServices.removeOrganizationUser(body), {
    onSuccess(_data, variables) {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetOrganizationUsers]
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.useGetOrganizationUserCount]
      });
      showSuccess({
        message: t('removeUserSuccessfully', { count: variables?.userCodes?.length || 1 }),
        type: 'toast'
      });
      options?.onSuccess?.();
    },
    ...options
  });
};
